import { useQuery } from '@tanstack/react-query';
import { getNutritionByMeal } from '../../../api/nutrition-service';

const useGetNutritionByMeal = ({ mealId, favoriteId, recipeId }) => {
    const params = {
        meal_id: mealId,
        favorite_meal_id: favoriteId,
        recipe_id: recipeId
    };

    const { data, isLoading, isError, error } = useQuery({
        queryKey: ['nutrition', 'meal', mealId, favoriteId, recipeId],
        queryFn: () => getNutritionByMeal(params),
        enabled: !!mealId || !!favoriteId || !!recipeId,
        staleTime: 1000 * 60 * 5,
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });

    return { data, isLoading, isError, error };
};

export default useGetNutritionByMeal;
